import React from 'react';

import { Tag } from 'antd';

export function MethodTag({method}) {

    const mapColor = () => {
        switch(method) {
            case 'get':
                return 'green';
            case 'post':
                return 'magenta';
            case 'put':
                return 'orange';
            case 'patch':
                return 'gold';
            case 'delete': 
                return 'geekblue';
        }
    }

    if(Array.isArray(method)) {
        return <Tag color="orange">many</Tag>
    }
    else {
        return <Tag color={mapColor()}>{method}</Tag>
    }
}
